module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAUVBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8v///8re8v0+P1vpdz6/P6awOZdmtfa6PY8hc/Z5/Y8hs+WvuVcmtfpjr8cAAAADnRSTlMARSjz3MeaAUDw2L+iKTHndiIAAACPSURBVBjTbY9ZDoMwDESdna0MSUig3P+gtdwU0dL3E8l5Y41J6LwFrFf0QY9ojLopBjWXlEquMJ04PeIyC0tEz15wiPNJhAukUMVZV/F2KPJ4yj8gT4Yni+06KrAEJE5B4GwCyFxGBy8DaPgObhycftdPpLC/SxxniXvV20GP/2ez59BwmhpBeQszeBWIeQH0pw7re59QkwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_add1.png
// module id = xNVL
// module chunks = 9